module.exports = __webpack_public_path__ + "static/media/slide3.f0fc3522.png";